import Roboto from './fonts/Roboto-Regular.ttf';
import RobotoMedium from './fonts/Roboto-Medium.ttf';
import RobotoLight from './fonts/Roboto-Light.ttf';
import RobotoCondensed from './fonts/RobotoCondensed-Bold.ttf';
import CastrolSanscon from './fonts/CastrolSansCon-Regular.ttf';

export const palette = {
  // castrol green
  primary: '#009343',
  // full-white, castrol white
  secondary: '#FFFFFF',
  // castrol red
  tertiary: '#F00023',
  // fullblack 
  black: '#000',
  ui: {
    // grey-100
    light: '#F2F2F2',
    // grey-400
    med: '#CCCCCC',
    // grey-500
    dark: '#666666'
  },
  neutrals: {
    // from castrol nextgen theme
    grey60: '#FAFAFA',
    grey200: '#EDEDED',
    grey300: '#DEDEDE',
    grey600: '#434343',
    grey700: '#343434',
    grey800: '#232323',
    grey900: '#111111',
    black: '#000000'
  },
  // castrol velvet
  accent01: '#C9015C',
  // castrol warm red
  accent02: '#FE4110',
  // castrol light tan
  accent03: '#AC9F83',
  // castrol light blue
  accent04: '#6A8DB6',
  // castrol medium gray
  accent05: '#999999',
  // castrol light gray
  accent06: '#DFDFDF',
  categoryCardBackground: '#ac9f83',
  darkPrimary: '#006E32',
  errorBorder: '#ff7591',
  errorBackground: '#fff5f7',
  infoBlueBackground: '#ecfafe',
  infoBlueBorder: '#4fc3f7',
  lightPrimary: '#B7DCC8',
  lightYellow: '#FAD350',

  notifications: {
    error: '#A80000',
    warning: '#ffcd00',
    success: '#006e32',
    info: '#1b61be',
    note: '#e6ecf3'
  },

  // text color is #111111 with different level of opacity (given by the last two digits in the color code)
  text: {
    // text black
    text01: '#000000',
    // text dark
    text02: '#000000',
    // text default
    text03: '#000000',
    // text grey
    text04: '#000000',
    // text body
    text05: '#000000',
    // text placeholder
    text06: '#000000'
  },

  metallic: {
    silver: '#B6B9BC'
  }
};

export const fontMap = {
  base: { name: 'Base', font: Roboto },
  baseLight: { name: 'Light', font: RobotoLight },
  baseMedium: { name: 'Base', font: RobotoMedium },
  heading: { name: 'Heading', font: RobotoCondensed },
  castrol: { name: 'Castrol', font: CastrolSanscon }
};

export const statics = {
  logo: '../brand/images/brand-12.svg',
  image:
    'https://www.castrol.com/content/dam/castrol/shared/About-Us/News-Events-Alerts/News-Events-Articles/Story%201%2C%20Picture%201.jpg'
};
